<div class="fy-dropdown-container" [ngClass]="customClass">
  <!-- Trigger Button -->
  <button
    type="button"
    class="fy-trigger"
    [class.is-open]="isOpen"
    [disabled]="disabled"
    (click)="toggleDropdown($event)"
  >
    <div class="fy-trigger-left">
      <svg
        class="fy-icon"
        [class.active]="isOpen"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
        <line x1="16" x2="16" y1="2" y2="6" />
        <line x1="8" x2="8" y1="2" y2="6" />
        <line x1="3" x2="21" y1="10" y2="10" />
      </svg>
      <span class="fy-selected-text">{{ displayLabel }}</span>
    </div>
    <svg
      class="fy-chevron"
      [class.rotated]="isOpen"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  </button>

  <!-- Dropdown Menu -->
  <div class="fy-dropdown-menu" *ngIf="isOpen">
    <div class="fy-item-list">
      <button
        type="button"
        class="fy-item"
        *ngFor="let opt of options"
        [class.is-selected]="isSelected(opt)"
        (click)="selectOption(opt, $event)"
      >
        <div class="fy-item-info">
          <div class="fy-item-header">
            <span class="fy-item-label" [class.active-label]="isSelected(opt)">
              {{ prefixText }} {{ opt.label }}
            </span>
            <span
              *ngIf="opt.isCurrent"
              class="fy-current-dot"
              title="Current Period"
            ></span>
          </div>
          <span class="fy-item-status">{{ opt.status }}</span>
        </div>
        <svg
          *ngIf="isSelected(opt)"
          class="fy-check-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </button>
    </div>

    <!-- Archive Footer Link -->
    <div class="fy-divider" *ngIf="showArchivedLink">
      <button
        type="button"
        class="fy-archive-link"
        (click)="onArchivedClick($event)"
      >
        {{ archivedText }}
      </button>
    </div>
  </div>
</div>
